import requests from '../../../../redux/reducer/requests';
import { useDispatch } from 'react-redux';

export default function usePremiumCallbacks() {
  const dispatch = useDispatch();

  return {
    buyPremium: (id) => dispatch(requests.thunks.buyPremium(id)),
    setPremiumIcon: (iconData) => dispatch(requests.thunks.setPremiumIcon(iconData)),
  };
}
